export const API_FEED_MODEL = {
    entity: 'feed',
    url: 'feed/',
    methods: {
        events: {
            url: 'events/'
        },
        excursions: {
            url: 'excursions/'
        },
        usefulResources: {
            url: 'useful-resources/'
        },
    },
}